import { z } from "zod";

import {
  ShopifyJobStatusList,
  ShopifyProductStatusList,
} from "../schemas/shopify";

export const DuplicateProductSyncStatusList = [
  "loading",
  "inProgress",
  "synced",
  "warning",
  "error",
] as const;
export type DuplicateProductSyncStatus =
  (typeof DuplicateProductSyncStatusList)[number];

export const DuplicateProductIssueList = [
  "priceMismatch",
  "comparePriceMismatch",
  "draftWhileTestLive",
  "productMissing",
  "variantMissing",
  "handleMismatch",
  "productTitleMismatch",
  "variantTitleMismatch",
  "denyOnNoInventory",
] as const;

export const DuplicateProductIssueActionList = [
  "syncWithShopify",
  "viewProductOnShopify",
  "viewVariantOnShopify",
  "recreateDuplicate",
  "markActive",
] as const;

export type DuplicateProductIssueActionType =
  (typeof DuplicateProductIssueActionList)[number];

export type DuplicateProductIssueType =
  (typeof DuplicateProductIssueList)[number];

export type DuplicateProductType = z.infer<typeof DuplicateProductSchema>;
export const DuplicateProductIssueDtoSchema = z.object({
  issueLevel: z.enum(["warning", "error"]),
  issueType: z.enum(DuplicateProductIssueList),
  variantId: z.string().optional(),
  dbValue: z.string(),
  shopifyValue: z.string(),
  message: z.string(),
  action: z.enum(DuplicateProductIssueActionList),
});
export type DuplicateProductIssueDto = z.infer<
  typeof DuplicateProductIssueDtoSchema
>;

export const DuplicateProductSchema = z.object({
  id: z.string(),
  productId: z.string(),
  productTitle: z.string().nullish(),
  productImage: z.string().nullish(),
  handle: z.string().nullish(),
  eventStatus: z.enum(ShopifyJobStatusList),
  variation: z.object({
    id: z.string().uuid(),
    name: z.string(),
    isControl: z.boolean(),
    shopifyStatus: z.enum(ShopifyProductStatusList).nullish(),
    syncStatus: z.enum(DuplicateProductSyncStatusList),
    issues: DuplicateProductIssueDtoSchema.array(),
    shopifyLink: z.string(),
  }),
});

export const SyncDuplicateProductsEventDtoSchema = z.object({
  direction: z.enum(["up", "down"]),
  issue: DuplicateProductIssueDtoSchema,
});

export type SyncDuplicateProductsEventDto = z.infer<
  typeof SyncDuplicateProductsEventDtoSchema
>;

export const SyncDuplicateProductsDtoSchema = z.object({
  variationId: z.string().uuid(),
  productId: z.string(),
  actions: SyncDuplicateProductsEventDtoSchema.array(),
});

export type SyncDuplicateProductsDto = z.infer<
  typeof SyncDuplicateProductsDtoSchema
>;
